/**
 * Синхронизация состояния кошелька при загрузке приложения
 * Выполняется ОДИН РАЗ в loader перед рендером
 *
 * Проверяет:
 * 1. Если локальный кошелек есть, а на backend нет - отключаем локальный
 * 2. Если оба есть, но адреса разные - отключаем локальный
 */

import { walletControllerGetWallets } from '@/api/wallet/wallet'
import { compareWalletAddresses } from './wallet-utils'

/**
 * Извлекает адрес из localStorage TON Connect
 */
const getLocalWalletAddress = (): string | null => {
  try {
    const tonConnectStorage = localStorage.getItem(
      'ton-connect-storage_bridge-connection',
    )
    if (!tonConnectStorage || tonConnectStorage === 'null') {
      return null
    }

    const parsed = JSON.parse(tonConnectStorage)
    // TON Connect хранит адрес в parsed.connectEvent?.payload?.items
    const account = parsed?.connectEvent?.payload?.items?.find(
      (item: { name: string }) => item.name === 'ton_addr',
    )
    return account?.address || null
  } catch {
    return null
  }
}

/**
 * Очищает все данные TON Connect из localStorage
 */
const clearTonConnectStorage = () => {
  const keysToRemove = [
    'ton-connect-storage_bridge-connection',
    'ton-connect-storage_http-connection-last-wallet-info',
    'ton-connect-ui_last-selected-wallet-info',
    'ton-connect-ui_preferred-wallet',
  ]
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}

export const syncWalletOnLoad = async (): Promise<void> => {
  try {
    // Получаем адрес локального кошелька
    const localAddress = getLocalWalletAddress()

    if (!localAddress) {
      // Нет локального кошелька - ничего не делаем
      return
    }

    // Получаем данные с backend
    const backendWallets = await walletControllerGetWallets()
    // Берем только АКТИВНЫЙ кошелек (isActive: true)
    const activeWallet = backendWallets?.find((w) => w.isActive)

    if (!activeWallet) {
      // Активного кошелька нет на backend - отключаем локальный
      clearTonConnectStorage()
      return
    }

    // Сравниваем адреса (нормализуем оба)
    const addressesMatch = compareWalletAddresses(
      localAddress,
      activeWallet.walletAddress,
    )

    if (!addressesMatch) {
      // Адреса не совпадают с активным - отключаем локальный
      clearTonConnectStorage()
      return
    }

    // Адреса совпадают с активным кошельком - оставляем локальный
  } catch {
    // Игнорируем ошибки - не критично для работы приложения
  }
}
